import axios from 'axios'; // eslint-disable-line no-restricted-imports -- TODO remove axios
import { getAuthenticityToken } from '~/utilities/getAuthenticityToken';

interface EventParams {
  action: string;
  hashedId: string;
  id?: number | string;
  displayName?: string;
}

const logEvent = async (
  type: string,
  { action, hashedId, id, displayName }: EventParams,
): Promise<unknown> => {
  axios.defaults.headers.common['X-CSRF-Token'] = getAuthenticityToken();
  const payload: Record<string, unknown> = {
    /* eslint-disable-next-line camelcase */
    event_action: action,
    hashed_id: hashedId,
  };

  if (id !== undefined) {
    payload.id = id;
  }

  if (displayName !== undefined) {
    payload.display_name = displayName;
  }

  return axios.post(`/data/event/${type}`, payload);
};

export const logProjectEvent = async (params: EventParams): Promise<unknown> =>
  logEvent('project', params);

export const logMediaEvent = async (params: EventParams): Promise<unknown> =>
  logEvent('media', params);
